import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/vip_level.png'
import _imports_1 from '@/assets/themeFour/copy-icon.png'
import _imports_2 from '@/assets/themeFour/refresh.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head_card" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"margin-top":"-10px"} }
const _hoisted_5 = { class: "contact" }
const _hoisted_6 = { class: "level" }
const _hoisted_7 = { class: "img-text" }
const _hoisted_8 = { class: "id" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { style: {"font-size":"20px","font-weight":"bold"} }

import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import defaultAvatar from '@/assets/themeFour/defaultAvatar.jpg';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'headCard',
  setup(__props) {

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const loadingRef = ref()
const currentLevel = computed(() => userStore.VIPData.currentLevel)
const avatarImg = computed(() => userStore.headimg)
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        router.push({ path: '/sd-withdraw' });
    } else if (type === 'topup') {
        router.push({ path: '/sd-topup' });
        localStorage.setItem('showDepositBackIcon', '1')
    }
}

async function refreshDetails() {
    try {
        loadingRef.value.open()
        await userStore.getInfo()
    } catch (e) {
        console.log(e);
    } finally {
        loadingRef.value.close()
    }
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, { class: "top-row-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "5",
            class: "avatar"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: avatarImg.value || _unref(defaultAvatar)
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "17",
            class: "detailsContainer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(name.value) + " ", 1),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('vip.title')) + " " + _toDisplayString(currentLevel.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t('profile.id')) + " : " + _toDisplayString(id.value) + " ", 1),
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(id.value))),
                    style: {"padding-left":"10px","width":"6%"}
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { class: "amount-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "12",
            class: "balance-col"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.balance')) + " ", 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "amount-sign" }, "R$", -1)),
                  _createTextVNode(_toDisplayString(_unref(formatCurrency)(balance.value)), 1)
                ]),
                _createElementVNode("img", {
                  onClick: refreshDetails,
                  src: _imports_2,
                  alt: "",
                  style: {"width":"8%"}
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "balance-col"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.todayBonus')) + " ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "value" }, [
                _createElementVNode("span", { style: {"font-size":"20px","font-weight":"400"} }, " 0,00")
              ], -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "12",
            class: "deposit_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.deposite'),
                class: "deposit-btn",
                textColor: "#fff",
                bgColor: "rgb(0, 86, 85)",
                icon: require('@/assets/themeFour/deposit.png'),
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (onButtonClick('topup')))
              }, null, 8, ["text", "icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "withdraw_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                text: _ctx.$t('common.sake'),
                class: "withdraw-btn",
                textColor: "#fff",
                bgColor: "rgb(0, 86, 85)",
                icon: require('@/assets/themeFour/withdraw.png'),
                onOnClick: _cache[2] || (_cache[2] = ($event: any) => (onButtonClick('withdraw')))
              }, null, 8, ["text", "icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"]),
    _createVNode(CarteiraView, { ref: "walletPopupRef" }, null, 512),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ]))
}
}

})